<template>
  <share
    v-if="renderShare"
    :url="blockAction ? blockAction.url : ''"
    ref="blockActionShare"
  />
</template>

<script>
import { mapActions } from "vuex"
import EventBus, { EVENTS } from "@/lib/event-bus"
import { isObject } from "@/lib/utils"

import BlockAction from "@/lib/mixins/block-action"
import Share from "@/components/block-actions/Share"

export default {
  mixins: [BlockAction],

  components: {
    Share
  },

  data() {
    return {
      renderShare: false,
      blockAction: null
    }
  },

  mounted() {
    if (!this.isPreview && this.isActionQueryPresent) {
      this.fetchAndTriggerBlockAction(this.$route.query["block-action"])
    }

    EventBus.$on(
      // TODO: Resolve merging to the link text PR. This refactoring is similar
      // Refer: https://github.com/FitterApp/fitter-pwa/pull/1010
      EVENTS.TRIGGER_BLOCK_ACTION,
      blockActionData => {
        if (isObject(blockActionData)) {
          this.blockAction = blockActionData

          this.triggerBlockAction()
        } else {
          this.fetchAndTriggerBlockAction(blockActionData)
        }
      }
    )
  },

  methods: {
    isObject,
    ...mapActions("auth", ["fetchBlockAction"]),

    async fetchAndTriggerBlockAction(blockActionId) {
      const response = await this.fetchBlockAction(blockActionId)
      this.blockAction = response.block_action

      this.triggerBlockAction()
    },

    triggerBlockAction() {
      if (this.isTriggerable) {
        this.trigger()

        return
      } else if (this.blockAction.action === "open_page") {
        this.$router.push(this.blockAction.link)
      } else if (this.isLink) {
        window.location.href = this.blockAction.link
      } else if (this.isShareLink) {
        this.renderShare = true
        this.$nextTick(() => {
          this.$refs.blockActionShare.share()
        })
      }

      this.$router.replace({ query: null })
    }
  }
}
</script>
